import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import './ProfileActions.css'

const ProfileActions = () => {
  const { uid } = useParams()
  const navigate = useNavigate()

  const actionItems = [
    {
      title: 'Liked in SETA',
      path: `/liked/${uid}`,
      description: 'View all datasets you have liked'
    },
    {
      title: 'Downloads in SETA',
      path: `/downloads/${uid}`,
      description: 'View your download history'
    }
  ]

  return (
    <div className="profile-actions">
      <div className="container">
        
        <div className="actions-grid">
          {actionItems.map((item, index) => (
            <div
              key={index}
              className="action-card"
              onClick={() => navigate(item.path)}
            >
              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              <div className="arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProfileActions